var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0621 0C10.2319 0 10.4057 0.0670929 10.5359 0.197384C10.7965 0.457966 10.7965 0.884399 10.5359 1.14498L1.6168 10.0681L10.4057 18.8569C10.6662 19.1175 10.6662 19.544 10.4057 19.8046C10.1451 20.0651 9.71866 20.0651 9.45808 19.8046L0.195425 10.5419C-0.0651579 10.2813 -0.0651579 9.85492 0.195425 9.59433L9.58837 0.197443C9.71866 0.0671501 9.89237 2.09808e-05 10.0621 2.09808e-05L10.0621 0Z",
    fill: "#D1D1D1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCloseIcon);
export default __webpack_public_path__ + "static/media/chatCloseIcon.5b8e5a210f202e83ffb2a44746ec7450.svg";
export { ForwardRef as ReactComponent };